import { Preloader } from 'mmfintech-portal-commons'

export const CustomPreloader = () => <Preloader color='rgba(247, 59, 32, 1)' />
